import React from "react";
import { Button, Col, Divider, Form, Modal, Row } from "antd";
import FormTextArea from "component/form/form_textarea";
import { useSelector } from "react-redux";
import { draftDialogOpenWarnSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
import { useDialogQC } from "hook/draft/dialog/useDialogsQC";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogQCWarn = () => {
  // -------------------------- VAR -----------------------------
  const { loading, handleCloseWarn, handleRateWarn } = useDialogQC();
  const [form] = Form?.useForm();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  const open = useSelector(draftDialogOpenWarnSelector);
  // -------------------------- FUNCTION ------------------------
  const handleConfirm = () => {
    form
      ?.validateFields()
      .then((values) => {
        if (values) {
          const reason = values?.reason;
          return handleRateWarn({ reason, form });
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={open}
      onCancel={() => handleCloseWarn(form)}
      title="Lý do cảnh cáo đoạn hội thoại này"
      footer={null}
      centered
    >
      <Form layout="vertical" form={form} id="dialog-qc-warn">
        <Divider />
        <Row>
          <Col xl={24} lg={24} md={24} xs={24}>
            <FormTextArea placeholder="Điền lý do" name="reason" />
          </Col>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Button
              onClick={handleConfirm}
              loading={loading}
              type="primary"
              block
            >
              Xác Nhận
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};
export default DialogQCWarn;
